import {
    KeyboardEvent,
} from 'react';

export default function(on: () => void | Promise<void>) {
    return function(e: KeyboardEvent): void {
        if (e.key !== 'Enter') {
            return;
        }

        e.preventDefault();
        on();
    };
}
